import styled from 'styled-components';

export const Container = styled.div`
  grid-area: statusControl;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors[1300]};
  padding: 1rem;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.gray100};
  legend {
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.colors.tertiary}!important;
    font-weight: 700;
    font-size: 16px;
    span {
      margin-left: 10px;
    }
  }
`;
